import {Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {TemplateSalvamentoModel} from '../../../../shared/model/template/template-salvamento-model';
import {TemplateMensagemComponent} from '../template-mensagem/template-mensagem.component';
import {
  BalaoInformativoComponent
} from '../../../../shared/components/balao-informativo/balao-informativo.component';
import {
  SlideTogglePadraoComponent
} from '../../../../shared/components/slide-toggle-padrao/slide-toggle-padrao.component';
import {FormFieldComponent} from '../../../../shared/components/form-field/form-field.component';
import {SelectOneComponent} from '../../../../shared/components/select-one/select-one.component';
import {
  DisparoAutomaticoVariavelModel
} from '../../../../shared/model/disparo-automatico/disparo-automatico-variavel.model';
import { ListaContatosModel } from '../../../../shared/model/disparo-automatico/lista-contatos.model';
import { MsgService } from '../../../../shared/service/msg.service';

@Component({
  selector: 'app-exibicao-template',
  standalone: true,
  imports: [
    TemplateMensagemComponent,
    BalaoInformativoComponent,
    SlideTogglePadraoComponent,
    FormFieldComponent,
    SelectOneComponent
  ],
  templateUrl: './exibicao-template.component.html',
  styleUrl: './exibicao-template.component.css'
})
export class ExibicaoTemplateComponent implements OnChanges {
  @Input() template: TemplateSalvamentoModel = new TemplateSalvamentoModel();
  @Input() tipo = 'Whatsapp';
  @Input() disabled = false;
  @Input() variaveis: DisparoAutomaticoVariavelModel[] = []
  @Input() listaContatos: ListaContatosModel[] = []
  @Input() colunasComplementares: string[] = [];
  @Input() origemContatos: 'EXCEL' | 'BASE_DINAMICA' = 'EXCEL';
  @Input() aguardandoCargaInicialContatos = false;

  private ultimaQuantidadeContatos = 0;

  get camposVariaveis(): string[] {
    if (!this.listaContatos?.length) {
      return [];
    }
    return ['Nome', 'E-mail', 'Telefone', 'CPF/CNPJ', ...this.colunasComplementares];
  }

  @Output() variaveisCriadas = new EventEmitter<DisparoAutomaticoVariavelModel[]>();

  private readonly msgService = inject(MsgService);


  ngOnChanges(changes: SimpleChanges) {
    this.normalizarVariaveisContato();

    if (changes['listaContatos']) {
      const novaQuantidade = this.listaContatos?.length ?? 0;
      const concluiuCargaInicial = changes['aguardandoCargaInicialContatos']?.previousValue === true
        && this.aguardandoCargaInicialContatos === false;

      if (!changes['listaContatos'].firstChange
          && !concluiuCargaInicial
          && this.ultimaQuantidadeContatos !== novaQuantidade) {
        this.resetarVariaveisContato();
      }

      this.ultimaQuantidadeContatos = novaQuantidade;
    }

    if((changes['template'] || changes['variaveis']) && this.variaveis.length === 0) {
      this.variaveis = [];
      this.template?.components.forEach(componente => {
        if (componente.type === 'BODY' && componente.example && componente.example.length > 0) {
          componente.example.forEach(exemplo => {
            const variavel: DisparoAutomaticoVariavelModel = new DisparoAutomaticoVariavelModel();
            variavel.ordem = exemplo.ordem!;
            this.variaveis.push(variavel);
          });
        }
      });
    }
  }

  selecionarTextoVariavel(event: string, index: number){
    this.variaveis[index].valor = event;
    this.variaveis[index].tipoCampoContato = 'Texto';
    this.variaveis = [...this.variaveis];
    this.variaveisCriadas.emit(this.variaveis);
  }

  selecionarTipoVariavel(index: number, event: any){
    this.variaveis[index].isCampoContato = event;
  }

  selecionarCampoContato(index: number, tipoCampo: string) {
    const tipoCampoNormalizado = this.normalizarTipoCampoContato(tipoCampo);
    const camposFixos = ['Nome', 'E-mail', 'Telefone', 'CPF/CNPJ'];
    const campoSelecionado = tipoCampoNormalizado ?? tipoCampo;
    const ehCampoComplementar = !camposFixos.includes(campoSelecionado);

    if(ehCampoComplementar) {
      const qtdInvalidos = this.listaContatos.filter(contato =>
        !this.buscarValorComplementar(contato, tipoCampo)).length;
      if (this.origemContatos === 'EXCEL' && qtdInvalidos > 0) {
        this.msgService.msgAdvertencia(
          `${qtdInvalidos} contato(s) não receberão a mensagem pois não têm valor na coluna ${tipoCampo}.`);
      }
      this.variaveis[index].tipoCampoContato = tipoCampo;
      this.variaveis[index].isCampoContato = true;
      this.variaveis[index].nomeColuna = tipoCampo;
      this.variaveis = [...this.variaveis];
      this.variaveisCriadas.emit(this.variaveis);
      return;
    }
    const qtdInvalidos = this.listaContatos.filter(contato => {
        switch (tipoCampo) {
            case 'E-mail':
                return !contato.email || !contato.isEmailValido;
            case 'CPF':
            case 'CPF/CNPJ':
                return !contato.cpf || !contato.isCpfValido;
            case 'Nome':
                return !contato.nomeContato || contato.nomeContato.trim() === '';
            case 'Telefone':
                return !contato.telefone || !contato.isContatoValido;
            default:
                return false;
        }
    }).length;

    if (this.origemContatos === 'EXCEL' && qtdInvalidos > 0) {
        this.msgService.msgAdvertencia(
            `${qtdInvalidos} contato(s) não receberão a mensagem pois têm ${tipoCampo} inválido.`);
    }

    this.variaveis[index].tipoCampoContato = campoSelecionado;
    this.variaveis[index].isCampoContato = true;
    this.variaveis = [...this.variaveis];
    this.variaveisCriadas.emit(this.variaveis);
  }


  resetarVariaveisContato() {
    let alterou = false;
    this.variaveis.forEach(v => {
      if (v.isCampoContato && v.nomeColuna) {
        v.isCampoContato = false;
        v.tipoCampoContato = undefined;
        v.valor = undefined;
        v.nomeColuna = undefined;
        v.colunaComplementarId = undefined;
        alterou = true;
      }
    });

    if (alterou) {
      this.msgService.msgAdvertencia(
        'A lista de contatos foi alterada. As colunas complementares selecionadas nas variáveis foram removidas. ' +
        'As colunas Nome, E-mail, Telefone e CPF/CNPJ foram mantidas.');
      this.variaveis = [...this.variaveis];
      this.variaveisCriadas.emit(this.variaveis);
    }

  }

  private normalizarTipoCampoContato(tipoCampo?: string): string | undefined {
    if (!tipoCampo) {
      return tipoCampo;
    }

    return tipoCampo === 'CPF' ? 'CPF/CNPJ' : tipoCampo;
  }

  private buscarValorComplementar(contato: ListaContatosModel, nomeColuna: string): string {
    const campos: any = contato.camposComplementares;
    if (Array.isArray(campos)) {
      const campo = campos.find((item: any) =>
        (item.nome ?? item.nomeColuna)?.localeCompare(nomeColuna, 'pt', {sensitivity: 'base'}) === 0);
      return String(campo?.valor ?? '').trim();
    }
    if (campos && typeof campos === 'object') {
      const chave = Object.keys(campos).find(nome =>
        nome.localeCompare(nomeColuna, 'pt', {sensitivity: 'base'}) === 0);
      return chave ? String(campos[chave] ?? '').trim() : '';
    }
    return '';
  }

  private normalizarVariaveisContato(): void {
    if (!this.variaveis?.length) {
      return;
    }

    let alterou = false;
    this.variaveis.forEach(variavel => {
      const tipoNormalizado = this.normalizarTipoCampoContato(variavel.tipoCampoContato);
      if (tipoNormalizado && tipoNormalizado !== variavel.tipoCampoContato) {
        variavel.tipoCampoContato = tipoNormalizado;
        alterou = true;
      }
    });

    if (alterou) {
      this.variaveis = [...this.variaveis];
      this.variaveisCriadas.emit(this.variaveis);
    }
  }
}
